<template>
  <md-card class="recruiting-card">
    <router-link :to="`/recruiting/${opportunity._id}`" class="recruiting-card__link">
      <div class="recruiting-card__banner" :style="communityStyle">
        <span class="recruiting-card__title">{{ opportunity.title || 'Untitled opportunity' }}</span>
        <span :class="['status-pill', `status-pill--${opportunity.status}`]">
          <span class="status-pill__dot"></span>
          {{ statusLabel(opportunity.status) }}
        </span>
        <i
          v-if="isFavorited"
          class="fa fa-star fa-lg gold-color recruiting-card__fav"
          aria-hidden="true"
          title="Favorite"
        ></i>
        <span class="recruiting-card__engagement">{{ engaged }} / {{ sentTo }}</span>
      </div>
    </router-link>
  </md-card>
</template>

<script>
import { statusLabel } from '../services/opportunityAdapter'
import { isFavorite } from '../services/recruitingFavoritesStore'

export default {
  props: {
    opportunity: { type: Object, required: true },
    communityStyle: {
      type: Object,
      default: () => ({ backgroundColor: 'white', color: 'black' })
    }
  },
  computed: {
    // Read-only favorite flag (client-side store). Drives the gold star that
    // marks a row as favorited; the toggle itself lives on the detail page.
    isFavorited() {
      return isFavorite(this.opportunity && this.opportunity._id)
    },
    // Header engagement counter — mirrors AskRow's "positiveResponse / recommendedAdvisors".
    // Numerator: clicks (used as a proxy for engaged/responded per PM guidance).
    // Denominator: alumni the opportunity was sent to (matched/emailed).
    engaged() {
      const e = this.opportunity && this.opportunity.engagement
      return (e && e.clicked) || 0
    },
    sentTo() {
      const e = this.opportunity && this.opportunity.engagement
      return (e && e.emailed) || 0
    }
  },
  methods: {
    statusLabel
  }
}
</script>

<style scoped>
/* Compact card — no whitespace around the color banner. */
.recruiting-card {
  margin: 0 0 20px 0;
  padding: 8px;
  overflow: hidden;
}
.recruiting-card__link,
.recruiting-card__link:hover,
.recruiting-card__link:focus { text-decoration: none !important; display: block; }
.recruiting-card__banner {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px;
  color: white;
}
.recruiting-card__title {
  font-weight: 600;
  font-size: 18px;
  color: inherit;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
/* Engagement counter — same size / weight / color as AskRow's `.positiveresponse`
   (see main.css: font-size 22px, weight 600, white). Pushed to the far right
   via margin-left:auto so the status pill stays snug to the title. */
.recruiting-card__engagement {
  margin-left: auto;
  font-size: 22px;
  font-weight: 600;
  color: inherit;
  white-space: nowrap;
}

/* Solid-fill status pill — same palette as the change-status buttons in
   RecruitingDetail (so a status "looks" the same across list and detail). */
.status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 999px;
  font-size: 1.4rem;
  font-weight: 600;
  color: #fff;
  /* Minimal white halo so the pill stays visible on any community bg color. */
  border: 1.5px solid rgba(255, 255, 255, 0.75);
  white-space: nowrap;
  text-decoration: none;
}
.status-pill__dot { width: 6px; height: 6px; border-radius: 50%; background: currentColor; opacity: 0.85; }
.status-pill--active     { background: #28a745; }
.status-pill--in_review  { background: #f59e0b; }
.status-pill--closed     { background: #6c757d; }   /* gray (swapped from orange) */
.status-pill--rejected   { background: #dc3545; }
.status-pill--incomplete { background: #3b82f6; }   /* vibrant blue (swapped from gray) */
.status-pill--quarantined { background: #475569; }
</style>



// WEBPACK FOOTER //
// src/components/RecruitingRow.vue